import { ViewModeTabs } from "../Home/components/ViewModeTabs";
import ProjectTabs from "../ProjectPage/components/ProjectTabs";
import { Link, useSearchParams } from "react-router-dom";

import ProjectDesignDocumentsTabsAllTab from "./Components/ProjectDesignDocumentsTabs/ProjectDesignDocumentsTabsAllTab/ProjectDesignDocumentsTabsAllTab";
import { UserRoles } from "../../types";
import { useUserRoleSelector } from "../../store/users/selectors";
import { ViewType } from "../../constants/enums";
import { enumFromStringValue } from "../../utils/enumFromStringValue";
import { PDDTable } from "./Components/PDDTable";

const ProjectDesignDocumentsTabs = [
  {
    title: "All",
    value: "all",
    content: <ProjectDesignDocumentsTabsAllTab />,
  },
  {
    title: "In Progress",
    value: "in-progress",
    content: <ProjectDesignDocumentsTabsAllTab />,
  },
  {
    title: "Completed",
    value: "completed",
    content: <ProjectDesignDocumentsTabsAllTab />,
  },
  {
    title: "Archived",
    value: "archived",
    content: <ProjectDesignDocumentsTabsAllTab />,
  },
];

const ProjectDesignDocuments = () => {
  const userRole = useUserRoleSelector();
  const [searchParams] = useSearchParams();
  const activeView: ViewType =
    enumFromStringValue(ViewType, searchParams.get("view")) ?? ViewType.GRID;

  return (
    <div className="p-4">
      {/* search input bar */}
      <div className="flex items-center justify-between">
        {/*<SearchInput />*/}
        <div />
        <div className="flex items-center gap-3">
          <ViewModeTabs activeView={activeView} />
          {(userRole === UserRoles.ADMIN || userRole === UserRoles.ADMIN_APPROVER) && (
            <Link
              className="rounded-full bg-primaryPurple-100 px-4 py-2 text-white"
              to="/Project-Design-Document/Add-New-PDD"
            >
              Add New PDD
            </Link>
          )}
        </div>
      </div>

      {/* tabs */}
      <div className="my-4 flex items-start justify-between gap-4">
        {/*<div className="basis-11/12">*/}
        {activeView === ViewType.GRID ? (
          <ProjectTabs projectDetailPageTabs={ProjectDesignDocumentsTabs} />
        ) : (
          activeView === ViewType.LIST && <PDDTable />
        )}
        {/*</div>*/}
        {/*<div>
          <div className="flex items-center gap-3">
            <button className="rounded-md border border-gray-300 p-2 hover:border-[#231F20]/10 hover:bg-primaryPurple-100/10">
              <IoFilter className="text-[#714ECE]" />
            </button>
            <button className="rounded-md border border-gray-300 p-2 hover:border-[#231F20]/10 hover:bg-primaryPurple-100/10">
              <span className="flex items-center gap-2">
                {userRole === UserRoles.ADMIN_APPROVER && (
                  <IoMdDownload className="text-[#714ECE]" />
                )}
                <IoMdArrowDropdown className="text-[#714ECE]" />
              </span>
            </button>
          </div>
        </div>*/}
      </div>
    </div>
  );
};

export default ProjectDesignDocuments;
